'use strict'

import $ from 'jquery'

const SCAN_TIMING = 4;
const VULNS = [{
  title: 'Apache Struts',
  version: '2.2.3',
  patchedVersion: '2.2.1',
  contents: `<b>CVE-2017-5638:</b><br/>Remote Code Execution`,
  score: 10
}, {
  title: 'OpenSSL',
  version: '0.9.2',
  patchedVersion: '1.0.1',
  contents: `<b>CVE-2014-0160:</b><br/>"HeartBleed"`,
  score: 10
}, {
  title: 'jQuery',
  version: '3.0.0',
  patchedVersion: '3.0.1',
  contents: `<b>CVE-2016-10707:</b><br/>Denial of Service`,
  score: 5.0
}, {
  title: 'Ruby on Rails',
  version: '3.1.0',
  patchedVersion: '3.1.2',
  contents: `<b>CVE-2013-0277:</b><br/>DoS Code Execution`,
  score: 10
}, {
  title: 'Spring Commons',
  version: '2.0.5',
  patchedVersion: '2.1.0',
  contents: `<b>CVE-2018-1273:</b><br/>Improper Data Validation`,
  score: 9.8
}]
let vulnIndex = 0;

const renderScoreBadge = (score, delay) => {
  delay = (delay - .1).toFixed(1);
  return `<svg class="cvss-hex" width="36" height="36" viewBox="0 0 50 50">
      <defs>
        <mask id="cvssHexMask">
          <path
            fill="#FFFFFF"
            d="M19,1 Q21,0,23,1 L39,10 Q41.5,11,42,14 L42,36 Q41.5,39,39,40 L23,49 Q21,50,19,49 L3,40 Q0.5,39,0,36 L0,14 Q0.5,11,3,10 L19,1"
          />
        </mask>
        <radialGradient id="pulseRadial">
          <stop offset="0%" stop-color="#FFFFFF" stop-opacity="0" />
          <stop offset="100%" stop-color="#FFFFFF" stop-opacity="1" />
        </radialGradient>
      </defs>
      <g mask="url(#cvssHexMask)">
        <g>
          <rect
            x="0"
            y="0"
            width="50"
            height="50"
            fill="#c42c2c"
          >
            <animate 
              attributeType="XML" 
              attributeName="fill" 
              fill="freeze"
              from="#c42c2c" 
              to="#36916d"
              dur=".3s"
              begin="${delay}s"/>
          </rect>
          <text x="20" y="32" fill="#FFFFFF" font-size="24px" text-anchor="middle">
            ${score}
            <animate
              attributeType="XML"
              attributeName="opacity"
              fill="freeze"
              from="1"
              to="0"
              dur=".3s"
              begin="${delay}s"/>
          </text>
          <text x="20" y="32" opacity="0" fill="#FFFFFF" font-size="24px" text-anchor="middle">
            0
            <animate
              attributeType="XML"
              attributeName="opacity"
              fill="freeze"
              from="0"
              to="1"
              dur=".3s"
              begin="${delay}s"/>
          </text>

          <g id="cvssPulse2" transform="translate(21, 25)">
            <animateTransform
              attributeName="transform"
              type="scale"
              from="0 0"
              to="1 1"
              begin="${delay}s"
              dur=".3s"
              additive="sum"
            />
            <circle
              cx="21"
              cy="25"
              r="25"
              stroke="#FFFFFF"
              fill="none"
              stroke-width="1px"
              transform="translate(-21, -25)"
            />
            <circle cx="21" cy="25" r="25" fill="url(#pulseRadial)" transform="translate(-21, -25)">
              <animate
                attributeType="xml"
                attributeName="fill-opacity"
                from="0"
                to="0"
                values="0;0.5;0"
                dur=".3s"
                begin=".2s"
                fill="freeze"
              />
            </circle>
          </g>
        </g>
        <g id="cvssLoader">
          <animate attributeType="xml" attributeName="opacity" from="1" to="0" dur=".4s" fill="freeze" />
          <rect x="0" y="0" width="50" height="50" fill="#CCCCCC" />
          <g id="cvssPulse" transform="translate(21, 25)">
            <animateTransform
              attributeName="transform"
              type="scale"
              from="0 0"
              to="1 1"
              begin="${delay}s"
              dur="2s"
              additive="sum"
              repeatCount="indefinite"
            />
            <circle
              cx="21"
              cy="25"
              r="25"
              stroke="#FFFFFF"
              fill="none"
              strokeWidth="1px"
              transform="translate(-21, -25)"
            />
            <circle cx="21" cy="25" r="25" fill="url(#pulseRadial)" transform="translate(-21, -25)">
              <animate
                attributeType="xml"
                attributeName="fill-opacity"
                from="0"
                to="0"
                values="0;0.5;0"
                dur="2s"
                begin=".2s"
                repeatCount="indefinite"
                fill="freeze"
              />
            </circle>
          </g>
          <g transform="translate(21, 25)">
            <g>
              <animateTransform
                id="innerCirBubble1"
                attributeName="transform"
                attributeType="XML"
                type="scale"
                from="1.2"
                to="1"
                begin="${delay}s; innerCirBubble2.end"
                dur="1s"
                fill="freeze"
              />
              <animateTransform
                id="innerCirBubble2"
                attributeName="transform"
                attributeType="XML"
                type="scale"
                from="1"
                to="1.2"
                begin="innerCirBubble1.end"
                dur="1s"
                fill="freeze"
              />
              <circle cx="21" cy="25" r="5" fill="#fff" transform="translate(-21, -25)" />
            </g>
          </g>
          <g transform="translate(21, 25)">
            <g>
              <animateTransform
                id="outerCirBubble1"
                attributeName="transform"
                attributeType="XML"
                type="scale"
                from="1"
                to="1.2"
                begin="${delay}s; outerCirBubble2.end"
                dur="1s"
                fill="freeze"
              />
              <animateTransform
                id="outerCirBubble2"
                attributeName="transform"
                attributeType="XML"
                type="scale"
                from="1.2"
                to="1"
                begin="outerCirBubble1.end"
                dur="1s"
                fill="freeze"
              />
              <circle
                cx="21"
                cy="25"
                r="11"
                stroke="#EEEEEE"
                fill="none"
                strokeWidth="1px"
                transform="translate(-21, -25)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>`;
}

const render = () => {
  // Reset render targets
  $('.code-scan').removeClass('active');
  $('.annotation-layer').removeClass('active').html('');
  $('.code-layer--hover').removeClass('active').html('');

  // Create animation components
  const badCodeLine = $('<div/>');
  const vulnCardAnnotation = $('<div/>');
  const xx = Math.round(Math.random() * 100);
  const yy = Math.round(Math.random() * 70);

  const vuln = VULNS[vulnIndex];
  vulnIndex++;
  if (vulnIndex >= VULNS.length) {
    vulnIndex = 0;
  }

  const vulnPatchDelay = (SCAN_TIMING * ((((100 - yy) * .4) + 20) / 100));

  vulnCardAnnotation.addClass('vuln-card').css({
    left: `${(xx * .5) + 10}%`,
    top: `${20 - (yy / 4)}%`,
    transform: `scale(${1 - (yy / 250)})`,
    animation: `vulnpatch .5s ease ${vulnPatchDelay.toFixed(1)}s 1 normal forwards`,
  }).html(`
    <h4 class="vuln-card-header">
      ${vuln.title}
      <div class="vuln-card-version-wrapper">
        <div class="vuln-card-version" style="animation: vulnCardVersionUpdate .5s ease-out ${(vulnPatchDelay + .1).toFixed(1)}s 1 normal forwards;">
          <i class="fossa-icon-close"></i> ${vuln.version}<br/>
          <i class="fossa-icon-locked"></i> ${vuln.patchedVersion}
        </div>
      </div>
    </h4>
    <div class="vuln-card-contents">
      <span class="vuln-score-badge">
        ${renderScoreBadge(vuln.score, vulnPatchDelay)}
      </span>
      <div class="vuln-card-contents-failure" style="animation: patchFadeOut .5s ease ${ (vulnPatchDelay - .1).toFixed(1) }s 1 normal forwards;">
        ${vuln.contents}
      </div>
      <div class="vuln-card-contents-success" style="animation: patchFadeIn .5s ease ${ (vulnPatchDelay - .1).toFixed(1) }s 1 normal forwards;">
        Patched in v${vuln.patchedVersion}
      </div>
    </div>
  `);

  const badeCodeY = ((yy / 100) * 15) + 30;
  badCodeLine.css({
    top: (Math.round(xx / 10) * 15) + 'px', // 13 rows at 15px height, 3 line code height
    left: `${badeCodeY}%`,
    animation: `codebump .5s ease ${(SCAN_TIMING * ((((100 - yy) * .4) + 15) / 100)).toFixed(1)}s 1 normal forwards`,
  }).addClass('bad-code-line')

  badCodeLine.html([
    '&nbsp;1101', 
    '01110100',
    '01&nbsp;10',
    '0111&nbsp;0',
    '10&nbsp;01&nbsp;1'].sort(() => 0.5 - Math.random()).slice(0, 3).join('<br/>'));

  requestAnimationFrame(() => setTimeout(() => {
    // Render animations
    $('.code-scan').addClass('active')
    $('.annotation-layer').addClass('active').append(vulnCardAnnotation);
    $('.code-layer--hover').addClass('active').append(badCodeLine);
    setTimeout(render, SCAN_TIMING * 1000);
  }, 1))
}

$(() => render());